import "../css/Home.css";
import { ParallaxProvider, ParallaxBanner } from "react-scroll-parallax";
import pageBackground from "../images/parallax.png";
import { Typography } from "@mui/material";
import axios from "axios";

const Home = () => {

	const downloadFile = (fileName) => {
		axios({
			method: "GET",
			url: `/download/${encodeURIComponent(fileName)}/`, // Add trailing slash
			responseType: "blob", // This is important for file downloads
		})
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', fileName); // Use the filename for the download
				document.body.appendChild(link);
				link.click();
				link.remove();
			})
			.catch((error) => {
				console.error("Error downloading file:", error);
			});
	};

	const caseStudies = [
		{ filename: "Reflective Worksheet.pdf", title: "Tools - Reflective worksheet for service providers" },
		{ filename: "Social Isolation Toolkit.pdf", title: "Tools - Social isolation and rough sleeping: A reflective toolkit for service providers"},
		{ filename: "Build on belief.pdf", title: "Case Study - Build on Belief weekend services" },
		{ filename: "Groundswell.pdf", title: "Case Study - Groundswell Homeless Health Peer Advocacy (HHPA) programme"},

	]


	return (
		<div className="landing-page">
			<ParallaxProvider className="container-body">
				<ParallaxBanner
					layers={[
						{
							image: pageBackground,
							speed: -130,
							key: "background-image",
							translateY: 80,
						},
					]}
					className="landing-background-image"
				></ParallaxBanner>
			</ParallaxProvider>
			<div className="landing-background-text">
				<div id="landing-background-text-title">
					How can we better support <br className="custom-break" />
					those rough sleeping and using{" "}
					<br className="custom-break" />
					substances in London?
				</div>
				<div id="landing-background-text-description">
					"For a long-time people have been talking about the opposite
					of addiction being connection, and so when we talk about
					like substance use problems and the root of those things, my
					experience has been that that is very much the case."
				</div>
			</div>
			<div className="landing-text-container">
				<Typography
					variant="h5"
					sx={{ fontWeight: "bold", fontSize: 30 }}
				>
					Pan-London Homeless Substance Use Programme
				</Typography>
				<Typography variant="body1" sx={{ fontSize: 18 }}>
					This online platform has been created to help answer this
					question. It will be used to share research and best
					practice from the project and signpost relevant resources,
					services and data.
				</Typography>
				<Typography variant="body1" sx={{ fontSize: 18 }}>
					If you'd like to explore our digital tools - an interactive
					evidence map, a service directory, and a data dashboard,
					please follow the links below:
				</Typography>
				<div className="button-container">
					<a id="evidence-map-button" href="/evidence-map/">
						Evidence Map
					</a>
					<a id="service-directory-button" href="/service-directory/">
						Service Directory
					</a>
					<a id="data-dashboard-button" href="/data-dashboard/">
						Data Dashboard
					</a>
				</div>
				<br></br>
				<Typography variant="h5" sx={{ fontWeight: "bold", fontSize: 30 }}>
					Tools & Case Studies
				</Typography>
				<ul>
					{caseStudies.map(({ filename, title }) => (
						<li 
							key={filename}
							style={{
							textDecoration: "underline",
							color: "#651e7a",
							fontSize: "18px"
								}}
						>
							<a	
								href={filename}
								onClick={(e) => {
									e.preventDefault(); // Prevent default anchor behavior
									downloadFile(filename); // Call downloadFile when clicked
								}}
							>
								{title}
							</a>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default Home;
